import { t } from '../../shared/i18n/index.js';

/** Derive backlinks from existing records. Removals override retained legacy refs. */
export function relatedNoteReasons({ notes, execution, routines, matchesReference }) {
  const reasons = new Map();
  const recorded = new Set();
  for (const entry of execution) {
    if (!matchesReference(entry, true)) continue;
    recorded.add(entry.noteId);
    if (!entry.removedAt) reasons.set(entry.noteId, t('views.noteReason.inList'));
  }
  for (const note of notes) {
    if (!recorded.has(note.id) && note.refnotes?.some(ref => matchesReference(ref, false))) {
      reasons.set(note.id, t('views.noteReason.taskReference'));
    }
  }
  for (const link of routines.links || []) {
    if (matchesReference(link, true)) reasons.set(link.noteId, t('views.noteReason.routineInList'));
  }
  for (const run of routines.runs || []) {
    if (!run.noteId || !matchesReference(run, true)) continue;
    if (routines.linkRecords?.some(link => link.noteId === run.noteId &&
        link.occurrenceId === run.occurrenceId && link.removed)) continue;
    reasons.set(run.noteId, t('views.noteReason.routineSession'));
  }
  return reasons;
}
